const prod = {
  url: {
    API_URL: "https://api.qatrace.com/api/",
    STORAGE_URL: "https://api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    NAME: "QA Trace",
  },
};

const stg = {
  url: {
    API_URL: "http://localhost:8000/api/",
    STORAGE_URL: "http://localhost:8000/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    NAME: "QA Trace",
  },
};

const dev = {
  url: {
    API_URL: "http://localhost:8000/api/",
    STORAGE_URL: "http://localhost:8000/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
    NAME: "QA Trace",
  },
};

// Determine which config to use based on environment
let selectedConfig;
if (process.env.NODE_ENV === "development") {
  selectedConfig = dev;
} else {
  // In production builds, check REACT_APP_ENV to choose between prod and stg
  const buildEnv = process.env.REACT_APP_ENV;
  selectedConfig = buildEnv === "stg" ? stg : prod;
}

export const config = selectedConfig;
